import { render, staticRenderFns } from "./full-term-of-payment.vue?vue&type=template&id=27908682"
import script from "./full-term-of-payment.vue?vue&type=script&lang=js"
export * from "./full-term-of-payment.vue?vue&type=script&lang=js"
import style0 from "./full-term-of-payment.vue?vue&type=style&index=0&id=27908682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports